module.exports = __webpack_public_path__ + "img/Ga.534dc561.png";